import React from "react"
import {Link} from "gatsby"
import cn from "classnames"
import "./RelatedProjectCard.scss"

const RelatedProjectCard = ({item}) => {
  return (
    <div className={cn("project-slide col-12 col-md-6 col-lg-4 mb-2 mb-lg-0 text-sm")}>
      <Link to={`/projects/${item.slug}`}>
        <div className="project-slide-inner">
          <div className="image-header">
            {
              item.featured_media && item.featured_media.localFile && (
                <img
                  src={item.featured_media.localFile.childImageSharp.fixed.src}
                  alt={item.featured_media.localFile.childImageSharp.fixed.originalName}
                  className="round-image"
                />
              )
            }
          </div>
          <h3>{item.title}</h3>
          <span className="text-dot" />
          <div className="project-description pb-2" dangerouslySetInnerHTML={{__html: item.excerpt}} />
        </div>
      </Link>
    </div>
  )
}

export default RelatedProjectCard
